import { render, staticRenderFns } from "./UserNavMenu.vue?vue&type=template&id=153d8b31&scoped=true&"
import script from "./UserNavMenu.vue?vue&type=script&lang=js&"
export * from "./UserNavMenu.vue?vue&type=script&lang=js&"
import style0 from "./UserNavMenu.vue?vue&type=style&index=0&id=153d8b31&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153d8b31",
  null
  
)

export default component.exports